import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductDescription extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      accordionBtn: '.js-accordionBtn',
      accordionBody: '.js-accordionBody',
    };

    this.dom = {
      $component: component,
      $accordionBtns: this.$getAll(this.refs.accordionBtn),
    };

    this.state = {
      openIndex: '1',
      openClass: 'open',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.openAccordionDrawer();
    this.setClickWithElement(dom.$accordionBtns, this.accordionBtnClick);
  }

  accordionBtnClick(btn) {
    const { state } = this;
    const { index } = btn.dataset;

    if (index === state.openIndex) {
      this.closeAccordionDrawer();
      state.openIndex = null;
      return;
    }

    if (state.openIndex) {
      this.closeAccordionDrawer();
    }

    state.openIndex = index;
    this.openAccordionDrawer();
  }

  openAccordionDrawer() {
    const { state, refs } = this;

    const btnSelector = `${refs.accordionBtn}[data-index="${state.openIndex}"]`;
    const activeBtn = this.$get(btnSelector);
    activeBtn.classList.add(state.openClass);

    const bodySelector = `${refs.accordionBody}[data-index="${state.openIndex}"]`;
    const body = this.$get(bodySelector);
    body.style.maxHeight = `${body.scrollHeight}px`;
    body.setAttribute('aria-hidden', 'false');
    body.setAttribute('aria-expanded', 'true');
  }

  closeAccordionDrawer() {
    const { state, refs } = this;

    const btnSelector = `${refs.accordionBtn}[data-index="${state.openIndex}"]`;
    const activeBtn = this.$get(btnSelector);
    activeBtn.classList.remove(state.openClass);

    const bodySelector = `${refs.accordionBody}[data-index="${state.openIndex}"]`;
    const body = this.$get(bodySelector);
    body.style.maxHeight = 0;
    body.setAttribute('aria-hidden', 'true');
    body.setAttribute('aria-expanded', 'false');
  }
}
